<template>
  <quick-rfq-parts isStatusAvailable />
</template>

<script>
export default {
  name: 'QuickRFQPartAvailable',
  components: {
    'quick-rfq-parts': () => import(/* webpackChunkName: 'QuickRFQPart' */ '@/components/Shared/RFQ_QuickRFQParts')
  }
}
</script>
